// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryCarouselAd-cls1_Xq7","cls2":"PodcastLibraryCarouselAd-cls2_QCv PodcastLibraryCarouselAd-cls1_Xq7"};